import * as ng from 'angular';

import { ApiHelperService } from '../../../shared';

export class TimeSlotsApi {
   apiUri:string;

   constructor(
      private apiHelper:ApiHelperService,
      eventId:number
   ) {
      this.apiUri = 'events/' + eventId + '/timeslots';
   }

   list() {
      return this.apiHelper.get(this.apiUri);
   }

   create(timeSlot) {
      return this.apiHelper.post(this.apiUri, timeSlot);
   }

   update(timeSlot) {
      return this.apiHelper.post(`${this.apiUri}/${timeSlot.id}`, timeSlot);
   }

   del(timeSlot, force = false) {
      let url = `${this.apiUri}/${timeSlot.id}?force=${force}`;

      return this.apiHelper.del(url);
   }
}

export type TimeSlotsApiFactory = (eventId:number) => TimeSlotsApi;

timeSlotsApiFactory.$inject = ['apiHelper'];
function timeSlotsApiFactory(apiHelper:ApiHelperService) {
   return function(eventId:number) {
      return new TimeSlotsApi(apiHelper, eventId);
   }
}

ng.module('e360').factory('timeSlotsApi', timeSlotsApiFactory);
